import React from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import { Box, Typography } from '@mui/material'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
import { useManageState } from './useManageState'
import StateComponents from '../../../../components/state-component/StateComponents'
import TableCustom from '../../../../components/table/tableCustom'
import { debouncedApiCall } from '../../../../utils/app.utils'
import { icons } from '../../../../assets/icons/icons'
import ModalCustom from '../../../../components/modal/modalCustomCms'
import CheckBoxCustom from '../../../../components/checkbox/CheckBoxCustom'
import { media_type_data } from '../../enum/elibrary_enum'
import UploadAllFile from '../../components/UploadAllFile'
import { useTranslation } from 'react-i18next'

type Props = {}

const ManageLibraryBanner: React.FC<Props> = ({ }: Props) => {
    const { t } = useTranslation();
    const {
        pathname,
        data,
        end_date,
        handleChangeDateRange,
        handleRequestSort,
        headCells,
        page,
        pageLimit,
        renderData,
        setPage,
        setPageLimit,
        set_search,
        sortBy,
        sortType,
        start_date,
        totalItems,
        handleCloseModal,
        showModal,
        set_showModal,
        handleSubmit,
        setFormState,
        formState,
        media_file,
        set_media_file
    } = useManageState();
    return (
        <ContainerLayout
            title={t("จัดการ Banner")}
            navigateContent={
                <NavigateListCustom
                    navigateData={[
                        {
                            key: "A",
                            name: t("จัดการข้อมูล E-Library"),
                            pathName: "จัดการข้อมูล E-Library", // i18n-ignore
                            disabled_match: true
                        },
                        {
                            key: "B",
                            name: t("จัดการ Banner"),
                            pathName: pathname
                        },
                    ]}
                />
            }
            content={
                <Box>
                    <StateComponents
                        otherProps={{ spacing: 2 }}
                        typeProps={[
                            {
                                seq: 1,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                    md: 6,
                                    xl: 3
                                },
                                fieldProps: {
                                    startAdornment: <Box sx={{ mr: 1 }}><icons.SearchNormal /></Box>,
                                    placeholder: t("ค้นหา ชื่อ"),
                                    onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: set_search })
                                }
                            },
                            {
                                seq: 3,
                                type: "DATE_RANGE2",
                                gridProps: {
                                    xs: 12,
                                    md: 6,
                                    xl: 3,
                                },
                                fieldProps: {
                                    handleChange: handleChangeDateRange,
                                    placeholder: t("ช่วงวันที่"),
                                    value: {
                                        end_date: end_date,
                                        start_date: start_date
                                    }
                                }
                            },
                            {
                                seq: 4,
                                type: "BUTTON",
                                gridProps: {
                                    xs: 12,
                                    md: 6,
                                },
                                fieldProps: {
                                    justifyContent: "flex-end",
                                    buttonData: [
                                        {
                                            seq: 1,
                                            maxWidth: 'fix-content',
                                            buttonProps: {
                                                onClick: () => set_showModal("ADD")
                                            },
                                            key: "เพิ่ม BANNER", // i18n-ignore
                                            label: t("เพิ่ม BANNER"),
                                            type: "ADD"
                                        }
                                    ],
                                }
                            }
                        ]}
                    />



                    <section className='w-full mt-4'>
                        <TableCustom
                            tableMinWidth={1440}
                            tableFixedWidth
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={headCells}
                            rowCount={totalItems}
                            rowsData={data?.map((data: any, i: any) => {
                                return renderData(data, i)
                            })}
                            onSort={handleRequestSort}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </section>


                    {showModal !== "" && (
                        <ModalCustom
                            handleClose={handleCloseModal}
                            onClick={handleSubmit}
                            open
                            enable_up_transition
                            title={t("เพิ่ม BANNER")}
                            subTitle={t("กรุณาระบุรายละเอียด")}
                            hintSubmitButton={showModal === 'VIEW'}
                            disabledSubmitButton={!formState.library_banner_name || !formState.library_seq}
                            scrollBody
                            form={
                                <Box className="w-full py-4">
                                    <StateComponents
                                        otherProps={{ spacing: 2 }}
                                        disabledAllField={showModal === 'VIEW'}
                                        typeProps={[
                                            {
                                                seq: 1,
                                                gridProps: {
                                                    xs: 12,
                                                },
                                                type: "TEXT-MASK",
                                                fieldProps: {
                                                    mode: "full_number",
                                                    heading: t("ลำดับการแสดงผล"),
                                                    value: formState.library_seq.toString(),
                                                    onChange: (e) => setFormState((prev) => ({ ...prev, library_seq: e.target.value })),
                                                    placeholder: t("ระบุชื่อ"),
                                                    required: true
                                                }
                                            },
                                            {
                                                seq: 2,
                                                gridProps: {
                                                    xs: 12,
                                                },
                                                type: "TEXT_FIELD",
                                                fieldProps: {
                                                    heading: t("ชื่อ"),
                                                    value: formState.library_banner_name,
                                                    onChange: (e) => setFormState((prev) => ({ ...prev, library_banner_name: e.target.value })),
                                                    placeholder: t("ระบุชื่อ"),
                                                    required: true
                                                }
                                            },
                                            {
                                                seq: 3,
                                                gridProps: {
                                                    xs: 12
                                                },
                                                type: "COMPONENT",
                                                fieldProps: {
                                                    element: (
                                                        <Box className="w-full">
                                                            <UploadAllFile
                                                                allow_media_file
                                                                view={showModal === 'VIEW'}
                                                                typeData={[
                                                                    {
                                                                        title: t("ไฟล์"),
                                                                        file: media_file,
                                                                        onFileChange: () => {
                                                                            // console.log(file, 'file')
                                                                            // set_cover_file(file || null);
                                                                        },
                                                                        onMediaFileChange: (data) => {
                                                                            set_media_file(data);
                                                                        },
                                                                        
                                                                        allow_type: ['IMAGE'],
                                                                        onDeleteFile: () => set_media_file(null),
                                                                        date: new Date()
                                                                    },
                                                                ]}
                                                            />
                                                        </Box>
                                                    )
                                                }
                                            }
                                        ]}
                                    />
                                </Box>
                            }
                        />
                    )}
                </Box>
            }
        />
    )
}

export default ManageLibraryBanner